import { AppLanguage } from '../i18n';

const textNodeOriginals = new WeakMap<Text, string>();

const exactZhToPl: Record<string, string> = {
  '首页配置': 'Konfiguracja strony',
  '商品管理': 'Produkty',
  '商品列表': 'Lista produktów',
  '商品组管理': 'Grupy produktów',
  '规格管理': 'Specyfikacje',
  '个人资料': 'Profil',
  '系统设置': 'Ustawienia',
  '退出登录': 'Wyloguj',
  '管理员': 'Administrator',
  '返回': 'Wróć',
  '返回列表': 'Wróć do listy',
  '编辑': 'Edytuj',
  '删除': 'Usuń',
  '查看': 'Podgląd',
  '移除': 'Usuń',
  '保存': 'Zapisz',
  '更新': 'Aktualizuj',
  '取消': 'Anuluj',
  '确认': 'Potwierdź',
  '搜索': 'Szukaj',
  '重置': 'Resetuj',
  '新增': 'Dodaj',
  '新增商品': 'Dodaj produkt',
  '新增商品组': 'Dodaj grupę produktów',
  '新增规格': 'Dodaj specyfikację',
  '新增子级': 'Dodaj element podrzędny',
  '新增根节点': 'Dodaj węzeł główny',
  '新增模块': 'Dodaj moduł',
  '编辑商品': 'Edytuj produkt',
  '编辑商品组': 'Edytuj grupę produktów',
  '编辑模块': 'Edytuj moduł',
  '确认删除': 'Potwierdź usunięcie',
  '确认移除': 'Potwierdź usunięcie',
  '确认添加': 'Potwierdź dodanie',
  '确认批量删除': 'Potwierdź usunięcie zbiorcze',
  '操作': 'Akcje',
  '状态': 'Status',
  '排序': 'Kolejność',
  '创建时间': 'Utworzono',
  '修改时间': 'Zmodyfikowano',
  '更新时间': 'Zaktualizowano',
  '商品详情': 'Szczegóły produktu',
  '商品图片': 'Zdjęcie produktu',
  '商品名称': 'Nazwa produktu',
  '商品名称（中文）': 'Nazwa produktu (chiński)',
  '商品类型': 'Typ produktu',
  '商品子类': 'Podtyp produktu',
  '商品ID': 'ID produktu',
  '商品组ID': 'ID grupy produktów',
  '商品组详情': 'Szczegóły grupy produktów',
  '商品组信息': 'Informacje o grupie produktów',
  '商品组名称': 'Nazwa grupy produktów',
  '商品组类型': 'Typ grupy produktów',
  '商品组规格': 'Specyfikacje grupy produktów',
  '商品规格': 'Specyfikacje produktu',
  '商品描述': 'Opis produktu',
  '特殊提示': 'Ważna informacja',
  '原价': 'Cena regularna',
  '折扣价': 'Cena promocyjna',
  '物流费用': 'Koszt dostawy',
  '物流时效': 'Czas dostawy',
  '关联商品': 'Powiązane produkty',
  '关联商品数': 'Liczba powiązanych produktów',
  '添加商品': 'Dodaj produkt',
  '添加商品到商品组': 'Dodaj produkt do grupy',
  '图片信息': 'Informacje o zdjęciach',
  '图片信息（多语言）': 'Zdjęcia (wiele języków)',
  '多语言内容': 'Treść wielojęzyczna',
  'LOGO（多语言）': 'LOGO (wiele języków)',
  '商品组名称（主）': 'Nazwa grupy produktów (główna)',
  '商品组编号': 'ID grupy produktów',
  '商品名称（主）': 'Nazwa produktu (główna)',
  '该语言暂无图片': 'Brak zdjęć w tym języku',
  '详情图片': 'Zdjęcia szczegółowe',
  '展示图片': 'Zdjęcia prezentacyjne',
  '上传LOGO': 'Prześlij LOGO',
  '重新上传': 'Prześlij ponownie',
  '上传图片': 'Prześlij zdjęcie',
  '添加详情图片': 'Dodaj zdjęcie szczegółowe',
  '添加展示图片': 'Dodaj zdjęcie prezentacyjne',
  'LOGO（中文）': 'LOGO (chiński)',
  'LOGO（English）': 'LOGO (angielski)',
  'LOGO（Polski）': 'LOGO (polski)',
  '详情图片（中文）': 'Zdjęcia szczegółowe (chiński)',
  '详情图片（English）': 'Zdjęcia szczegółowe (angielski)',
  '详情图片（Polski）': 'Zdjęcia szczegółowe (polski)',
  '展示图片（中文）': 'Zdjęcia prezentacyjne (chiński)',
  '展示图片（English）': 'Zdjęcia prezentacyjne (angielski)',
  '展示图片（Polski）': 'Zdjęcia prezentacyjne (polski)',
  '图片URL（中文）': 'URL obrazu (chiński)',
  '图片URL（English）': 'URL obrazu (angielski)',
  '图片URL（Polski）': 'URL obrazu (polski)',
  'Banner图片': 'Obraz banera',
  'Banner图片（多语言）': 'Obrazy banera (wiele języków)',
  '多语言配置': 'Konfiguracja wielojęzyczna',
  '中文名称': 'Nazwa chińska',
  '英文名称': 'Nazwa angielska',
  '波兰语名称': 'Nazwa polska',
  '波兰名称': 'Nazwa polska',
  '中文名称:': 'Nazwa chińska:',
  '英文名称:': 'Nazwa angielska:',
  '波兰名称:': 'Nazwa polska:',
  '规格详情': 'Szczegóły specyfikacji',
  '规格信息': 'Informacje o specyfikacji',
  '规格名称': 'Nazwa specyfikacji',
  '规格类型': 'Typ specyfikacji',
  '规格分类': 'Kategoria specyfikacji',
  '父级规格': 'Specyfikacja nadrzędna',
  '内容': 'Treść',
  '分类': 'Kategoria',
  '启用': 'Włącz',
  '禁用': 'Wyłącz',
  '已上架': 'Opublikowany',
  '已下架': 'Wycofany',
  '上架': 'Opublikuj',
  '下架': 'Wycofaj',
  '是否上架': 'Czy opublikowany',
  '暂无': 'Brak',
  '暂无描述': 'Brak opisu',
  '暂无商品': 'Brak produktów',
  '暂无图片': 'Brak obrazu',
  '暂无配置数据': 'Brak danych konfiguracji',
  '暂无Banner图片': 'Brak obrazów banera',
  '商品不存在': 'Produkt nie istnieje',
  '商品上架成功': 'Produkt opublikowany',
  '商品下架成功': 'Produkt wycofany',
  '删除成功': 'Usunięto',
  '删除失败': 'Usuwanie nie powiodło się',
  '操作失败': 'Operacja nie powiodła się',
  '更新成功': 'Zaktualizowano',
  '新增成功': 'Dodano',
  '保存失败': 'Zapisywanie nie powiodło się',
  '图片上传成功': 'Zdjęcie przesłane',
  '图片上传失败': 'Przesyłanie zdjęcia nie powiodło się',
  '图片已删除': 'Zdjęcie usunięte',
  'LOGO上传成功': 'LOGO przesłane',
  '获取商品详情失败': 'Nie udało się pobrać szczegółów produktu',
  '获取商品列表失败': 'Nie udało się pobrać listy produktów',
  '获取商品组详情失败': 'Nie udało się pobrać szczegółów grupy produktów',
  '获取商品组列表失败': 'Nie udało się pobrać listy grup produktów',
  '获取关联商品失败': 'Nie udało się pobrać powiązanych produktów',
  '获取规格列表失败': 'Nie udało się pobrać listy specyfikacji',
  '获取规格详情失败': 'Nie udało się pobrać szczegółów specyfikacji',
  '搜索失败': 'Wyszukiwanie nie powiodło się',
  '更新失败': 'Aktualizacja nie powiodła się',
  '新增失败': 'Dodawanie nie powiodło się',
  '添加商品失败': 'Dodawanie produktu nie powiodło się',
  '移除成功': 'Usunięto',
  '移除失败': 'Usuwanie nie powiodło się',
  '请选择要添加的商品': 'Wybierz produkty do dodania',
  '删除功能待实现': 'Funkcja usuwania będzie dostępna później',
  '商品块': 'Blok produktów',
  '商品信息': 'Informacje o produkcie',
  '组件库': 'Biblioteka komponentów',
  '页面画布': 'Obszar strony',
  '属性面板': 'Panel właściwości',
  '基本信息': 'Informacje podstawowe',
  '代码': 'Kod',
  '标题': 'Tytuł',
  'Banner设置': 'Ustawienia banera',
  '图片URL': 'URL obrazu',
  '跳转URL': 'URL przekierowania',
  '跳转类型': 'Typ przekierowania',
  '商品设置': 'Ustawienia produktu',
  '未设置': 'Nie ustawiono',
  '添加子组件': 'Dodaj komponent podrzędny',
  '点击画布里的组件展示组件的详情': 'Kliknij komponent na obszarze, aby zobaczyć szczegóły',
  '可以在这里修改组件属性': 'Tutaj możesz zmienić właściwości komponentu',
  '首页配置树状结构': 'Struktura konfiguracji strony',
  '配置树': 'Drzewo konfiguracji',
  '可视化编辑': 'Edycja wizualna',
  '树状结构': 'Struktura drzewa',
  '预览首页': 'Podgląd strony',
  '父级节点': 'Węzeł nadrzędny',
  '模块类型': 'Typ modułu',
  '模块名称': 'Nazwa modułu',
  '模块标题': 'Tytuł modułu',
  '备注': 'Uwagi',
  '文本内容区域': 'Obszar tekstu',
  '图片展示区域': 'Obszar obrazu',
  '图片已设置': 'Obraz ustawiony',
  '商品展示区域': 'Obszar produktów',
  'Banner轮播区域': 'Obszar karuzeli banerów',
  '更多': 'więcej',
  '拖拽': 'Przeciągnij',
  '子组件': 'Komponenty podrzędne',
  '拖拽到这里成为子组件': 'Upuść tutaj, aby utworzyć komponent podrzędny',
  '点击或拖拽左侧组件至此处': 'Kliknij lub przeciągnij komponent z lewej strony tutaj',
  '组件添加成功': 'Komponent dodany',
  '创建组件失败': 'Tworzenie komponentu nie powiodło się',
  '排序更新成功': 'Kolejność zaktualizowana',
  '更新排序失败': 'Aktualizacja kolejności nie powiodła się',
  '模块移动成功': 'Moduł przeniesiony',
  '更新区域失败': 'Aktualizacja obszaru nie powiodła się',
  '拖拽失败: 找不到拖拽的组件': 'Przeciąganie nie powiodło się: nie znaleziono komponentu',
  '拖拽失败: 缺少数据': 'Przeciąganie nie powiodło się: brakuje danych',
  '添加子节点': 'Dodaj węzeł podrzędny',
  '确定要删除这个配置项吗？': 'Czy na pewno usunąć tę pozycję konfiguracji?',
  '请选择父级节点（不选则为根节点）': 'Wybierz węzeł nadrzędny (puste oznacza węzeł główny)',
  '请选择模块类型': 'Wybierz typ modułu',
  '请输入模块名称': 'Wpisz nazwę modułu',
  '请输入模块标题': 'Wpisz tytuł modułu',
  '请输入备注': 'Wpisz uwagi',
  '搜索商品名称': 'Szukaj nazwy produktu',
  '搜索商品组名称': 'Szukaj nazwy grupy produktów',
  '搜索规格名称': 'Szukaj nazwy specyfikacji',
  '请选择商品类型': 'Wybierz typ produktu',
  '请选择商品子类': 'Wybierz podtyp produktu',
  '请输入排序': 'Wpisz kolejność',
  '请输入原价': 'Wpisz cenę regularną',
  '请输入折扣价': 'Wpisz cenę promocyjną',
  '请输入物流费用': 'Wpisz koszt dostawy',
  '请输入商品描述（中文）': 'Wpisz opis produktu (chiński)',
  '请输入特殊提示（中文）': 'Wpisz ważną informację (chiński)',
  '请输入物流时效（中文），例如：1 个工作日': 'Wpisz czas dostawy (chiński), np. 1 dzień roboczy',
  '请输入商品名称（English）': 'Wpisz nazwę produktu (angielski)',
  '请输入商品描述（English）': 'Wpisz opis produktu (angielski)',
  '请输入特殊提示（English）': 'Wpisz ważną informację (angielski)',
  '请输入物流时效（English），例如：1 business day': 'Wpisz czas dostawy (angielski), np. 1 business day',
  '请输入商品名称（Polski）': 'Wpisz nazwę produktu (polski)',
  '请输入商品描述（Polski）': 'Wpisz opis produktu (polski)',
  '请输入特殊提示（Polski）': 'Wpisz ważną informację (polski)',
  '请输入物流时效（Polski），例如：1 dzień roboczy': 'Wpisz czas dostawy (polski), np. 1 dzień roboczy',
  '请输入商品名称（中文）': 'Wpisz nazwę produktu (chiński)',
  '请输入商品描述': 'Wpisz opis produktu',
  '请输入特殊提示': 'Wpisz ważną informację',
  '请选择要关联的商品': 'Wybierz produkty do powiązania',
  '只能选择具体规格项': 'Można wybrać tylko konkretne pozycje specyfikacji',
  '只能选择已绑定商品中包含的规格项': 'Można wybrać tylko specyfikacje występujące w powiązanych produktach',
  '输入规格名称': 'Wpisz nazwę specyfikacji',
  '请输入中文名称': 'Wpisz nazwę chińską',
  '请输入英文名称': 'Wpisz nazwę angielską',
  '请输入波兰名称': 'Wpisz nazwę polską',
  '选择显示语言': 'Wybierz język wyświetlania',
  '内容下不能新增子级': 'Nie można dodać elementu podrzędnego pod treścią',
  '确定要删除这个规格吗？': 'Czy na pewno usunąć tę specyfikację?',
  '更新规格成功': 'Specyfikacja zaktualizowana',
  '新增顶级规格成功': 'Dodano specyfikację główną',
  '新增子级规格成功': 'Dodano specyfikację podrzędną',
  '第': 'Od',
  '条/总共': 'z',
  '条': 'rekordów',
  // 表格列 / 通用标签
  '类型': 'Typ',
  '子类型': 'Podtyp',
  '价格': 'Cena',
  '物流': 'Dostawa',
  '名称': 'Nazwa',
  '图标': 'Ikona',
  '名称:': 'Nazwa:',
  '类型:': 'Typ:',
  '备注:': 'Uwagi:',
  '父级:': 'Nadrzędny:',
  '个': 'szt.',
  '无': 'Brak',
  // 确认对话框
  '确定要删除这个商品吗？': 'Czy na pewno usunąć ten produkt?',
  '确定要删除这个商品组吗？': 'Czy na pewno usunąć tę grupę produktów?',
  '确定要从商品组中移除这个商品吗？': 'Czy na pewno usunąć ten produkt z grupy?',
  // 操作结果
  '批量删除成功': 'Usunięto zbiorczo',
  '批量删除失败': 'Zbiorcze usuwanie nie powiodło się',
  '加载中...': 'Ładowanie...',
  'LOGO上传失败': 'Przesyłanie LOGO nie powiodło się',
  'LOGO已删除': 'LOGO usunięte',
  '更新商品组成功': 'Grupa produktów zaktualizowana',
  '新增商品组成功': 'Grupa produktów dodana',
  '保存商品组失败': 'Zapisywanie grupy produktów nie powiodło się',
  '更新商品成功': 'Produkt zaktualizowany',
  '新增商品成功': 'Produkt dodany',
  '更新商品失败': 'Aktualizacja produktu nie powiodła się',
  '新增商品失败': 'Dodawanie produktu nie powiodło się',
  '获取可选规格失败': 'Nie udało się pobrać dostępnych specyfikacji',
  '商品组不存在': 'Grupa produktów nie istnieje',
  '获取首页配置失败': 'Nie udało się pobrać konfiguracji strony',
  '首页低代码配置': 'Konfiguracja strony (low-code)',
  '通过组件库、页面画布和属性面板维护用户侧首页模块。': 'Zarządzaj modułami strony głównej przez bibliotekę komponentów, obszar i panel właściwości.',
  '刷新': 'Odśwież',
  '低代码画布': 'Obszar low-code',
  '拖到画布中的可投放区域': 'Przeciągnij do obszaru docelowego na kanwie',
  '请拖拽组件到画布中的对应模块': 'Przeciągnij komponent do odpowiedniego modułu na kanwie',
  '拖拽组件到蓝色区域，或使用组件右上角按钮调整层级和排序': 'Przeciągnij komponenty do niebieskich stref lub użyj przycisków w rogu modułu',
  '桌面': 'Desktop',
  '手机': 'Telefon',
  '暂无首页模块，从左侧拖入一个组件开始配置': 'Brak modułów — przeciągnij komponent z lewej strony',
  '选择画布组件后编辑': 'Wybierz komponent na kanwie, aby edytować',
  '点击画布中的模块查看属性': 'Kliknij moduł na kanwie, aby zobaczyć właściwości',
  '当前选中：': 'Wybrano:',
  '父级': 'Nadrzędny',
  '根级': 'Poziom główny',
  '编辑属性': 'Edytuj właściwości',
  '前台影响': 'Wpływ na front',
  '多语言 Banner 图片会影响用户侧当前语言的首页轮播。': 'Wielojęzyczne banery (obraz/wideo) wpływają na karuzelę na stronie głównej.',
  '多语言 Banner 图片/视频会影响用户侧当前语言的首页轮播。': 'Wielojęzyczne banery (obraz/wideo) wpływają na karuzelę na stronie głównej.',
  '选择的商品组决定用户点击卡片后进入哪个商品组详情。': 'Wybrana grupa produktów decyduje, do której strony szczegółów trafi użytkownik.',
  '子组件会作为商品组卡片展示在这个商品组块里。': 'Elementy podrzędne są wyświetlane jako karty grup produktów.',
  '商品组内容回显': 'Podgląd grupy produktów',
  '点击下方卡片可以打开商品组详情，方便核对多语言内容和配置。': 'Kliknij kartę, aby otworzyć szczegóły grupy i zweryfikować treści.',
  '拖到这里调整顺序': 'Upuść tutaj, aby zmienić kolejność',
  '拖入 Banner 图': 'Upuść baner',
  '拖入商品组信息': 'Upuść informacje o grupie produktów',
  '张 Banner': 'banerów',
  '个商品组': 'grup produktów',
  '删除后该模块不再在首页展示，确认继续？': 'Moduł zniknie ze strony głównej. Kontynuować?',
  '不能移动到自己的子组件内': 'Nie można przenieść do własnego komponentu podrzędnego',
  '已启用': 'Włączono',
  '已禁用': 'Wyłączono',
  '已移到根级': 'Przeniesiono na poziom główny',
  '已设为子组件': 'Ustawiono jako komponent podrzędny',
  '位置已更新': 'Pozycja zaktualizowana',
  '拖拽排序失败': 'Zmiana kolejności nie powiodła się',
  '状态更新失败': 'Aktualizacja statusu nie powiodła się',
  '商品组块': 'Blok grup produktów',
  '未知模块': 'Nieznany moduł',
  '未识别模块': 'Nierozpoznany moduł',
  '未配置名称': 'Brak nazwy',
  '暂无特殊提示': 'Brak ważnej informacji',
  '未配置商品组': 'Brak skonfigurowanej grupy',
  '商品编号': 'Kod produktu',
  '确认上架商品': 'Potwierdź publikację',
  '确认下架商品': 'Potwierdź wycofanie',
  '确定要上架这个商品吗？': 'Czy na pewno opublikować ten produkt?',
  '确定要下架这个商品吗？': 'Czy na pewno wycofać ten produkt?',
  '确定要删除选中的': 'Czy na pewno usunąć wybrane',
  '个商品吗？': ' produkty?',
  '获取详情失败': 'Nie udało się pobrać szczegółów',
  '更新组件位置失败': 'Aktualizacja pozycji komponentu nie powiodła się',
  '暂无备注': 'Brak uwag',
  // 首页配置
  '首页配置管理': 'Zarządzanie konfiguracją strony',
  'Banner块': 'Blok banera',
  '承载多个 Banner 图，通常放在首页顶部': 'Zawiera wiele banerów, zwykle na górze strony głównej',
  '单张 Banner 图片，可配置多语言图片': 'Pojedynczy baner z wielojęzycznymi obrazami',
  '承载多个商品组入口，展示为商品组卡片区域': 'Wiele wejść do grup produktów — wyświetlane jako karty',
  '绑定商品组 ID，点击进入商品组详情': 'Powiązanie z ID grupy — kliknięcie otwiera szczegóły grupy',
  'Banner图': 'Baner',
  '文本块': 'Blok tekstu',
  '图片块': 'Blok obrazu',
  '顶部区域': 'Obszar górny',
  '中间区域': 'Obszar środkowy',
  '底部区域': 'Obszar dolny',
  '前面': 'przed',
  '后面': 'za',
  '内部': 'wewnątrz',
  // 商品 / 商品组类型
  '电动车': 'Pojazd elektryczny',
  '电动滑板': 'Hulajnoga elektryczna',
  '配件': 'Akcesoria',
  '电动车商城': 'Sklep pojazdów elektrycznych',
  '电动自行车': 'Rower elektryczny',
  'VIP权益': 'Uprawnienia VIP',
  // 表单
  '商品组名称（中文）': 'Nazwa grupy produktów (chiński)',
  '请输入商品组名称（中文）': 'Wpisz nazwę grupy produktów (chiński)',
  '请输入商品组名称（English）': 'Wpisz nazwę grupy produktów (angielski)',
  '请输入商品组名称（Polski）': 'Wpisz nazwę grupy produktów (polski)',
  '请选择商品组类型': 'Wybierz typ grupy produktów',
  '请输入备注（中文）': 'Wpisz uwagi (chiński)',
  '请输入备注（English）': 'Wpisz uwagi (angielski)',
  '请输入备注（Polski）': 'Wpisz uwagi (polski)',
  '请输入排序值': 'Wpisz wartość kolejności',
  '排序值，数字越小越靠前': 'Mniejsza liczba = wyżej na liście',
  '是否显示': 'Czy wyświetlać',
  '显示': 'Pokaż',
  '隐藏': 'Ukryj',
  '从已绑定商品的规格中选择作为商品组的规格': 'Wybierz specyfikacje z powiązanych produktów jako specyfikacje grupy',
  '请先保存商品组并添加商品': 'Najpierw zapisz grupę i dodaj produkty',
  '请先保存商品组并添加商品，然后才能配置规格': 'Najpierw zapisz grupę, dodaj produkty, a następnie skonfiguruj specyfikacje',
  // 规格管理
  '编辑规格': 'Edytuj specyfikację',
  '请输入规格名称': 'Wpisz nazwę specyfikacji',
  '请选择类型': 'Wybierz typ',
  '请选择父级分类': 'Wybierz kategorię nadrzędną',
  '父级分类': 'Kategoria nadrzędna',
  // 校验 / 提示
  '例如：400，前台统一展示为 zł': 'Np. 400, na stronie wyświetlane jako zł',
  '请求失败': 'Żądanie nie powiodło się',
  '请求超时，请重试': 'Przekroczono limit czasu, spróbuj ponownie',
  '文件大小不能超过': 'Rozmiar pliku nie może przekraczać',
  '上传超时，请检查网络连接或文件大小': 'Przekroczono limit czasu przesyłania, sprawdź sieć lub rozmiar pliku',
  '文件过大，请选择小于50MB的文件': 'Plik jest za duży, wybierz plik mniejszy niż 50 MB',
  '文件过大，请选择小于500MB的文件': 'Plik jest za duży, wybierz plik mniejszy niż 500 MB',
  '文件上传中断，请重试': 'Przesyłanie przerwane, spróbuj ponownie',
  '创建时间:': 'Utworzono:',
  '修改时间:': 'Zmodyfikowano:',
  '代码:': 'Kod:',
  '标题:': 'Tytuł:',
  '排序:': 'Kolejność:',
  '状态:': 'Status:',
  '图片URL:': 'URL obrazu:',
  '跳转URL:': 'URL przekierowania:',
  '跳转类型:': 'Typ przekierowania:',
  '商品ID:': 'ID produktu:',
  '+ 点击或拖拽左侧组件至此处': '+ Kliknij lub przeciągnij komponent z lewej strony tutaj',
  '📍 拖拽到这里成为子组件': '📍 Upuść tutaj, aby utworzyć komponent podrzędny',
  '子组件 (': 'Komponenty podrzędne (',
  '🖼️ Banner轮播区域': '🖼️ Obszar karuzeli banerów',
  '🛒 商品展示区域': '🛒 Obszar produktów',
  '🛒 商品': '🛒 Produkt',
  '📝 文本内容区域': '📝 Obszar tekstu',
  '🖼️ 图片展示区域': '🖼️ Obszar obrazu',
  '已选择': 'Wybrano',
  '个商品': 'produktów',
  '个规格（只能选择具体规格项）': 'specyfikacji (można wybrać tylko konkretne pozycje)',
  '个规格（只能选择已绑定商品中包含的规格项）': 'specyfikacji (tylko specyfikacje z powiązanych produktów)',
  '请选择左侧规格项查看详情': 'Wybierz specyfikację po lewej, aby zobaczyć szczegóły',
};

const exactPlToZh: Record<string, string> = {
  ...Object.fromEntries(Object.entries(exactZhToPl).map(([zh, pl]) => [pl, zh])),
  // 与 i18n.ts actionEnable/actionDisable 及历史 DOM 译文对齐
  Włączone: '启用',
  Wyłączone: '禁用',
};

const translateTemplate = (text: string, language: AppLanguage): string => {
  if (language === 'zh') {
    return text;
  }

  return text
    .replace(/^确认(上架|下架)商品$/, (_, action) => `Potwierdź ${action === '上架' ? 'publikację' : 'wycofanie'} produktu`)
    .replace(/^确定要(上架|下架)这个商品吗？$/, (_, action) => `Czy na pewno ${action === '上架' ? 'opublikować' : 'wycofać'} ten produkt?`)
    .replace(/^成功添加 (\d+) 个商品到商品组$/, 'Dodano $1 produktów do grupy')
    .replace(/^确定要删除选中的 (\d+) 个商品吗？$/, 'Czy na pewno usunąć wybrane produkty ($1)?')
    .replace(/^已选择 (\d+) 个商品$/, 'Wybrano $1 produktów')
    .replace(/^已选择 (\d+) 个规格（只能选择具体规格项）$/, 'Wybrano $1 specyfikacji (można wybrać tylko konkretne pozycje)')
    .replace(/^已选择 (\d+) 个规格（只能选择已绑定商品中包含的规格项）$/, 'Wybrano $1 specyfikacji (tylko specyfikacje z powiązanych produktów)')
    .replace(/^第 (\d+)-(\d+) 条\/总共 (\d+) 条$/, 'Pozycje $1-$2 z $3')
    .replace(/^详情图片(\d+)$/, 'Zdjęcie szczegółowe $1')
    .replace(/^展示图片(\d+)$/, 'Zdjęcie prezentacyjne $1')
    .replace(/^商品 (\d+)$/, 'Produkt $1')
    .replace(/^Banner (\d+)$/, 'Baner $1')
    .replace(/^\+(\d+) 更多$/, '+$1 więcej')
    .replace(/^子组件 \((\d+)\)$/, 'Komponenty podrzędne ($1)')
    .replace(/^标题: (.*)$/, 'Tytuł: $1')
    .replace(/^ID: (.*)$/, 'ID: $1')
    .replace(/^费用：/, 'Koszt: ')
    .replace(/^时效：/, 'Czas: ')
    .replace(/^将 "(.+)" 移动到 "(.+)" 内部$/, 'Przenieś "$1" do wnętrza "$2"')
    .replace(/^将 "(.+)" 移动到 "(.+)" 附近$/, 'Przenieś "$1" w pobliże "$2"')
    .replace(/^组件已移动到 (.+)$/, 'Komponent przeniesiony $1')
    .replace(/^✅ 将 "(.+)" 移动到 "(.+)" 内部$/, '✅ Przenieś "$1" do wnętrza "$2"')
    .replace(/^📍 将 "(.+)" 移动到 "(.+)" 附近$/, '📍 Przenieś "$1" w pobliże "$2"')
    .replace(/^(\d+) 个$/, '$1 szt.')
    .replace(/^文件大小不能超过 (\d+)MB$/, 'Rozmiar pliku nie może przekraczać $1 MB');
};

/** 语言名称等固定文案：切波兰语界面时也保持母语，便于各国用户识别 */
const NEVER_TRANSLATE_TERMS = new Set([
  '中文',
  'Polski',
  'English',
  'EN',
  'PL',
  'Edison-Admin',
  'Edison-Admin 后台系统',
  'Panel Edison-Admin',
  '🇨🇳 中文',
  '🇺🇸 English',
  '🇵🇱 Polski',
]);

const translateExact = (text: string, language: AppLanguage): string => {
  if (language === 'pl' && NEVER_TRANSLATE_TERMS.has(text)) {
    return text;
  }
  const exactMap = language === 'pl' ? exactZhToPl : exactPlToZh;
  return exactMap[text] || translateTemplate(text, language);
};

const translateWithWhitespace = (value: string, language: AppLanguage): string => {
  if (!value || !value.trim()) {
    return value;
  }

  const leading = value.match(/^\s*/)?.[0] || '';
  const trailing = value.match(/\s*$/)?.[0] || '';
  const trimmed = value.trim();
  const translated = translateExact(trimmed, language);
  return `${leading}${translated}${trailing}`;
};

const translatableAttributes = ['placeholder', 'title', 'aria-label', 'alt'];

const translateElementAttributes = (element: Element, language: AppLanguage) => {
  translatableAttributes.forEach((attr) => {
    const current = element.getAttribute(attr);
    if (!current) {
      return;
    }

    const originalAttr = `data-i18n-original-${attr}`;
    if (language === 'zh') {
      if (element.hasAttribute(originalAttr)) {
        element.setAttribute(attr, element.getAttribute(originalAttr) || current);
        return;
      }
      const trimmed = current.trim();
      if (exactPlToZh[trimmed]) {
        element.setAttribute(attr, current.replace(trimmed, exactPlToZh[trimmed]));
      }
      return;
    }

    if (!element.hasAttribute(originalAttr)) {
      element.setAttribute(originalAttr, current);
    }

    const original = element.getAttribute(originalAttr) || current;
    element.setAttribute(attr, translateWithWhitespace(original, language));
  });
};

const shouldSkipElement = (element: Element | null): boolean => {
  if (!element) {
    return false;
  }
  return Boolean(
    element.closest(
      'script, style, code, pre, textarea, .language-select, .language-select-dropdown, [data-i18n-ignore="true"]'
    )
  );
};

const translateTextNode = (node: Text, language: AppLanguage) => {
  if (shouldSkipElement(node.parentElement)) {
    return;
  }

  const current = node.nodeValue || '';
  const trimmed = current.trim();
  if (!trimmed) {
    return;
  }

  if (language === 'zh') {
    const zhFromPl = exactPlToZh[trimmed];
    if (zhFromPl) {
      if (node.nodeValue !== current.replace(trimmed, zhFromPl)) {
        node.nodeValue = current.replace(trimmed, zhFromPl);
      }
      textNodeOriginals.set(node, zhFromPl);
      return;
    }
    const cached = textNodeOriginals.get(node);
    if (cached && !exactPlToZh[cached.trim()]) {
      if (node.nodeValue !== cached) {
        node.nodeValue = cached;
      }
      return;
    }
    return;
  }

  if (!textNodeOriginals.has(node)) {
    textNodeOriginals.set(node, current);
  }

  const source = textNodeOriginals.get(node) || current;
  const translated = translateWithWhitespace(source, language);
  if (node.nodeValue !== translated) {
    node.nodeValue = translated;
  }
};

export const translateAdminDom = (language: AppLanguage, root: ParentNode = document.body) => {
  if (!root) {
    return;
  }

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  let current = walker.nextNode();
  while (current) {
    translateTextNode(current as Text, language);
    current = walker.nextNode();
  }

  if (root instanceof Element) {
    translateElementAttributes(root, language);
  }

  root.querySelectorAll?.('*').forEach((element) => {
    translateElementAttributes(element, language);
  });
};

let observer: MutationObserver | null = null;

export const installAdminDomTranslator = (getLanguage: () => AppLanguage) => {
  if (observer) {
    return;
  }

  observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          translateTextNode(node as Text, getLanguage());
          return;
        }

        if (node.nodeType === Node.ELEMENT_NODE) {
          translateAdminDom(getLanguage(), node as Element);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
};
